import { httpClient } from '../../../httpClient';

import { IAgency } from './models';

export const getAgency = (): Promise<IAgency> => {
    return httpClient.get('agency');
};
